import { API, axiosInstance } from "lib";

export const getVendersListData = (data={}) => {
  return axiosInstance
    .post(API.GET_VENDOR_LIST , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const createVenders = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_VENDOR , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const editVenders = (data = {}) => {
  return axiosInstance
    .post(API.EDIT_VENDOR , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const getSingleVenderData = (data={}) => {
  return axiosInstance
    .post(API.GET_SINGLE_VENDOR , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const deleteVendersData = (data={}) => {
  return axiosInstance
    .post(API.DELETE_VENDOR , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const changeVendorStatusData = (data={}) => {
  return axiosInstance
    .post(API.CHANGE_VENDOR_STATUS , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};